<!-- VUE Component that wraps our drawing canvas and owns the global 'paint' instance attached to that canvas -->

<template>
  <div class="drawing-panel halftone container">
    <div class="drawing-canvas overlay tool-cursor-{{ state.tool }}">
      <canvas id="paintcanvas" width="512" height="288"></canvas>
    </div>
  </div>
</template>


<style lang="scss">

  .drawing-panel {
    position: relative;
    width: 100%;
    height: 230px;
    border: 1px solid black;
    border-width: 1px 0;
    overflow: hidden;
  }

  .drawing-canvas {
    position: absolute;
    width: 512px;
    //height: 512px;
    height: 288px;

    background-color: #fff;
    top: 0;
    bottom: 0;
    left: 24px;

    canvas {
      width: 100%;
      height: auto;
      position: absolute;
      cursor: crosshair;
    }

    #paintcanvas {

    }

    #tmp_canvas {

    }

    #overlay_canvas {
      pointer-events: none;
    }

    #hint_canvas {
      pointer-events: none;
    }

    #select_canvas {
      outline: 1px dashed #000;
      cursor: move;
      width: auto;
      //z-index: 10;
      opacity: 1.0;
    }


    &.tool-cursor-move canvas {
      cursor: move;
    }

    &.dragging {

      // no pointer event on select rect when dragging
      #select_canvas {
        cursor: move;
        pointer-events: none;
      }

      #tmp_canvas {
        cursor: move;
      }

    }


  }

</style>

<script>

  import state from '../data/state';
  import canvasPaint from '../util/canvasPaint';

  let p;

  export default{
    data(){
      return {
        state
      }
    },
    ready(){
      p = canvasPaint(this.$el, state);
    },
    beforeDestroy() {
      p.destroy();
    },
  }

</script>



// WEBPACK FOOTER //
// DrawingPanel.vue?23cae6e0